import Axios from "axios";
import Config from "@/config/index.js";
// eslint-disable-next-line no-unused-vars
import {
  getToken,
  removeToken,
  removeOrgInfo,
  removeOrgId
} from "@/utils/common.js";
import { Toast } from "vant";
const service = Axios.create({
  baseURL: Config.apiUrl + "/" + Config.apiPrefix,
  headers: {
    Accept: "*/*"
  },
  timeout: Config.timeout
});

service.defaults.retry = Config.requestRetry;
service.defaults.retryDelay = Config.requestRetryDelay;
// let LoadingInstance = null;

service.interceptors.request.use(
  config => {
    if (config.showLoading) {
      //加载提示
      window.LoadingInstance = Toast.loading({
        mask: true,
        message: "加载中..."
      });
    }
    config.headers["businessSource"] = Config.businessSource;
    config.headers["terminalPlatform"] = Config.terminalPlatform;
    config.headers["requestId"] = Config.requestId;
    config.headers["loginType"] = Config.loginType; //重要，否则使用登陆系统登陆的 token 没法使用
    let token = getToken();
    if (token && !config.noToken) {
      //如果有 token 并且没有在配置里添加 noToken:true 才会带上token
      config.headers["Authorization"] = token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  res => {
    if (window.LoadingInstance) {
      setTimeout(() => {
        window.LoadingInstance.clear();
      }, 500);
    }
    if (res.status !== 200) {
      //Toast('数据返回出错');
      return Promise.reject("响应非200！");
    } else {
      if (res.config.closeAllIntercept) {
        return res.data;
      }
      if (res.data.code == 100004 || res.data.code == 100003) {
        //token过期
        removeToken();
        removeOrgInfo();
        removeOrgId();
        if (window.location.href.indexOf("index.html") === -1) {
          window.location.href = "./index.html";
        } else {
          window.location.reload();
        }
        return;
      }

      if (res.data.code != 100000) {
        console.log(res.config.closeInterceptors);
        if (res.config.closeInterceptors) {
          return Promise.reject(res.data); //自己处理错误
        }
        //统一处理错误
        Toast(res.data.msg || res.data.message); //message是志峰的工具报的错
        return Promise.reject("error");
      }
      return res.data.data;
    }
  },
  error => {
    if (window.LoadingInstance) {
      setTimeout(() => {
        window.LoadingInstance.clear();
      }, 500);
    }
    //Toast("网络错误");
    return Promise.reject(error);
  }
);

export default service;
